import React from "react";
import PageHeader from "../components/PageHeader";
import TestimonialComponent from "../components/Testimonial";

const Testimonial = () => {
  return (
    <>
      <PageHeader title="Testimonial" />
      <TestimonialComponent />
    </>
  );
};

export default Testimonial;
